/** @jsx h */
import { useEffect, useRef } from 'preact/hooks';
import { labels } from '../../config';
import { ClickRedirect } from '@3pc/click-redirect';
import { Tooltip } from '@3pc/tooltip';

const TeaserMedia = ({ result }) => {
  const clickRedirect = useRef(null);
  const clickRedirectTarget = useRef(null);

  const tooltipUrl = href => {
    const origin = window.location.origin;
    const url = `${
      href.includes('https://') || href.includes('http://') ? '' : origin
    }${href}`;

    return url;
  };

  useEffect(() => {
    const clickRedirectEl = clickRedirect.current;
    const clickRedirectTargetEl = clickRedirectTarget.current;

    if (!clickRedirectEl || !clickRedirectTargetEl) return;

    // Click redirect
    const clickRedirectInstance = new ClickRedirect(
      clickRedirectEl,
      clickRedirectTargetEl
    );

    clickRedirectInstance.activate();

    // Tooltip
    const tooltipInstance = new Tooltip(clickRedirectEl, {
      contentAttribute: 'data-tooltip',
      tooltipIsHoverable: false,
      tooltipAlignLeft: true,
      tooltipHasTargetMaxWidth: true,
      targetIsFocusable: false,
    });

    tooltipInstance.init();
  });

  return (
    <article
      className={`teaser-news ${
        result.mediaType === 'Video'
          ? 'teaser-news--video'
          : result.mediaType === 'Audio'
          ? 'teaser-news teaser-news--audio'
          : ''
      } ${result.image ? 'teaser-news--picture' : ''} click-redirect-parent `}
    >
      {result.image ? (
        <figure class="teaser-news__figure">
          {result.mediaType === 'Video' ||
          result.mediaType === 'Audio' ||
          result.mediaType === 'Podcast' ? (
            <span
              className={`icon--in-circle teaser-news__icon icon icon--${
                result.mediaType === 'Video'
                  ? 'video'
                  : result.mediaType === 'Audio' ||
                    result.mediaType === 'Podcast'
                  ? 'audio'
                  : ''
              }`}
            >
              <svg class="icon__svg" role="img" aria-hidden="true">
                <use
                  href={`#icon-${
                    result.mediaType === 'Video'
                      ? 'video'
                      : result.mediaType === 'Audio' ||
                        result.mediaType === 'Podcast'
                      ? 'audio'
                      : ''
                  }`}
                />
              </svg>
              <span class="sr-only">{result.mediaType}</span>
            </span>
          ) : (
            ''
          )}
          <picture class="picture teaser-news__picture">
            {result.image.sources &&
              result.image.sources.map((source, index) => (
                <source
                  key={index}
                  media={
                    source.minWidth > 0
                      ? `(min-width: ${source.minWidth}px)`
                      : false
                  }
                  srcset={source.srcset}
                />
              ))}
            <img src={result.image.src} loading="lazy" alt="" />
          </picture>
        </figure>
      ) : result.mediaType === 'Video' ||
        result.mediaType === 'Audio' ||
        result.mediaType === 'Podcast' ? (
        <div class="teaser-news__decoration">
          <span
            className={`icon--in-circle teaser-news__icon icon icon--${
              result.mediaType === 'Video'
                ? 'video'
                : result.mediaType === 'Audio' || result.mediaType === 'Podcast'
                ? 'audio'
                : ''
            }`}
          >
            <svg class="icon__svg" role="img" aria-hidden="true">
              <use
                href={`#icon-${
                  result.mediaType === 'Video'
                    ? 'video'
                    : result.mediaType === 'Audio' ||
                      result.mediaType === 'Podcast'
                    ? 'microphone'
                    : ''
                }`}
              />
            </svg>
            <span class="sr-only">{result.mediaType}</span>
          </span>
          {result.mediaType === 'Podcast' && (
            <span class="teaser-news__issue" aria-hidden="true">
              {result.mediaType}
            </span>
          )}
        </div>
      ) : (
        ''
      )}
      <div class="teaser-news__teaser">
        <header class="teaser-news__header">
          {result.mark && (
            <div className="teaser-news__category">
              <div className="meta-category meta-category--teaser-news">
                <span className="meta-category__icon" />
                <span className="sr-only">{labels.document.category}</span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: Array.isArray(result.mark)
                      ? result.mark.join(
                          '<span class="meta-category__separator" aria-hidden="true">|</span>'
                        )
                      : result.mark,
                  }}
                />
              </div>
            </div>
          )}
          {result.event && (
            <div className="teaser-news__event">
              <div className="meta-event ">
                {result.event.date && (
                  <div className="meta-event__day">
                    <span className="meta-event__icon meta-event__icon--day icon icon--calendar">
                      <svg className="icon__svg" role="img" aria-hidden="true">
                        <use href="#icon-calendar" />
                      </svg>

                      <span className="sr-only">{labels.document.date}</span>
                    </span>
                    <time className="meta-event__day-start">
                      {result.event.date}
                    </time>
                  </div>
                )}
                {result.event.time && (
                  <div className="meta-event__time">
                    <span className="meta-event__icon meta-event__icon--time icon icon--clock">
                      <svg className="icon__svg" role="img" aria-hidden="true">
                        <use href="#icon-clock" />
                      </svg>

                      <span className="sr-only">{labels.document.time}</span>
                    </span>
                    <time>
                      {result.event.time} {labels.document.clock}
                    </time>
                  </div>
                )}
                {result.event.location && (
                  <div className="meta-event__location">
                    <span className="meta-event__icon meta-event__icon--location icon icon--map-pin-small">
                      <svg className="icon__svg" role="img" aria-hidden="true">
                        <use href="#icon-map-pin-small" />
                      </svg>
                      <span className="sr-only">
                        {labels.document.location}
                      </span>
                    </span>
                    <div class="meta-event__text">{result.event.location}</div>
                  </div>
                )}
              </div>
            </div>
          )}
          {result.publishingDate && (
            <time className="teaser-news__date">{result.publishingDate}</time>
          )}
          <h3
            class={`teaser-news__heading${
              result.url ? ' click-redirect-source' : ''
            }`}
            data-click-redirect={result.url ? true : null}
            data-tooltip={result.url ? tooltipUrl(result.url) : null}
            ref={result.url ? clickRedirect : null}
          >
            {result.title}
          </h3>
        </header>
        {result.teaser && (
          <div class="teaser-news__content">
            <p>{result.teaser}</p>
          </div>
        )}
        {result.teaserHtml && (
          <div
            class="teaser-news__content"
            dangerouslySetInnerHTML={{
              __html: result.teaserHtml,
            }}
          />
        )}
        {result.url && (
          <footer class="teaser-news__footer">
            <a
              class="styled-link styled-link--boxed-white teaser-news__footer-link click-redirect-target"
              ref={clickRedirectTarget}
              href={result.url}
              {...(result.isExternal
                ? { target: '_blank', rel: 'noopener' }
                : '')}
            >
              {result.isExternal ? (
                <span class="styled-link__icon icon icon--arrow-external">
                  <svg class="icon__svg" role="img" aria-hidden="true">
                    <use href="#icon-arrow-external" />
                  </svg>

                  <span class="sr-only">{labels.document.externalLink}:</span>
                </span>
              ) : (
                <span class="styled-link__icon icon icon--arrow-internal">
                  <svg class="icon__svg" role="img" aria-hidden="true">
                    <use href="#icon-arrow-internal" />
                  </svg>
                </span>
              )}
              {result.linkText}
              <span class="sr-only">{result.title}</span>
            </a>
          </footer>
        )}
      </div>
    </article>
  );
};

export default TeaserMedia;
